import React from 'react'

function Footer() {
    return (
        <div>
            <footer style={{ marginTop: "auto", padding: "20px", background: "#f8f8f8" }}>
                <h5>Smart CRM</h5>
                <p>©2025 Social Partners Technologies Private Limited. All rights reserved. </p>
                {/* Optional: add social icons or partner logos here */}
            </footer>
        </div>
    )
}

export default Footer